// TODO(jordan): verify these numbers before promoting this bar —
// they are estimates and should reflect real business metrics.
// Update values here once confirmed.
const stats = [
  { value: "300+", label: "Agents Served" },
  { value: "45+", label: "Brokerages" },
  { value: "5,000+", label: "Listings Captured" },
];

const SocialProofBar = () => {
  return (
    <section className="py-5 bg-primary/5 border-b border-border">
      <div className="container mx-auto px-6">
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12">
          {stats.map((stat, i) => (
            <div key={stat.label} className="flex items-center gap-3">
              {i > 0 && (
                <span className="hidden md:block w-px h-8 bg-border" />
              )}
              <div className="text-center">
                <span className="font-serif font-bold text-xl text-foreground">{stat.value}</span>
                <span className="text-muted-foreground text-sm ml-2">{stat.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofBar;
